import Ajax from './ajax';
import { LOGGED_OFF } from './authentication';
import TenantCompany from '../domain/tenantcompany';

// TenantCompany backend now exists (see doc/sweden-expansion-currency-plan.md, Phase 1).
// This module fetches the tenants assigned to the current user and lets them switch the active one.

export const FETCH_TENANTS_REQUESTED = 'tenantdata/FETCH_TENANTS_REQUESTED';
export const FETCHED_TENANTS = 'tenantdata/FETCHED_TENANTS';
export const FETCH_TENANTS_FAILED = 'tenantdata/FETCH_TENANTS_FAILED';

export const SELECT_TENANT_REQUESTED = 'tenantdata/SELECT_TENANT_REQUESTED';
export const SELECT_TENANT_SUCCESS = 'tenantdata/SELECT_TENANT_SUCCESS';
export const SELECT_TENANT_FAILED = 'tenantdata/SELECT_TENANT_FAILED';

export const FETCH_ALL_TENANTS_REQUESTED = 'tenantdata/FETCH_ALL_TENANTS_REQUESTED';
export const FETCHED_ALL_TENANTS = 'tenantdata/FETCHED_ALL_TENANTS';
export const FETCH_ALL_TENANTS_FAILED = 'tenantdata/FETCH_ALL_TENANTS_FAILED';

export const SAVE_TENANT_REQUESTED = 'tenantdata/SAVE_TENANT_REQUESTED';
export const SAVED_TENANT = 'tenantdata/SAVED_TENANT';
export const SAVE_TENANT_FAILED = 'tenantdata/SAVE_TENANT_FAILED';

const initialState = {
    tenants: [],
    activeTenantId: null,
    isFetching: false,
    isSelecting: false,
    allTenants: [],
    isFetchingAllTenants: false,
    isSaving: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TENANTS_REQUESTED:
            return { ...state, isFetching: true };
        case FETCHED_TENANTS:
            return {
                ...state,
                isFetching: false,
                tenants: action.tenants,
                activeTenantId: action.activeTenantId,
            };
        case FETCH_TENANTS_FAILED:
            return { ...state, isFetching: false };
        case SELECT_TENANT_REQUESTED:
            return { ...state, isSelecting: true };
        case SELECT_TENANT_SUCCESS:
            return { ...state, isSelecting: false, activeTenantId: action.tenantId };
        case SELECT_TENANT_FAILED:
            return { ...state, isSelecting: false };
        case FETCH_ALL_TENANTS_REQUESTED:
            return { ...state, isFetchingAllTenants: true };
        case FETCHED_ALL_TENANTS:
            return { ...state, isFetchingAllTenants: false, allTenants: action.data.map((t) => new TenantCompany(t)) };
        case FETCH_ALL_TENANTS_FAILED:
            return { ...state, isFetchingAllTenants: false };
        case SAVE_TENANT_REQUESTED:
            return { ...state, isSaving: true };
        case SAVED_TENANT: {
            const savedTenant = new TenantCompany(action.tenant);

            const newAllTenants = [...state.allTenants];
            const allIdx = newAllTenants.findIndex((t) => t.id === savedTenant.id);
            if (allIdx > -1) {
                newAllTenants[allIdx] = savedTenant;
            } else {
                newAllTenants.push(savedTenant);
            }

            // Keep the tenant-switcher's own list (fetched separately via getTenants(), not
            // refreshed on save) in sync too, so it reflects the updated tenant data immediately.
            const newTenants = [...state.tenants];
            const tenantsIdx = newTenants.findIndex((t) => t.id === savedTenant.id);
            if (tenantsIdx > -1) {
                newTenants[tenantsIdx] = savedTenant;
            } else {
                newTenants.push(savedTenant);
            }

            return {
                ...state,
                isSaving: false,
                allTenants: newAllTenants,
                tenants: newTenants,
            };
        }
        case SAVE_TENANT_FAILED:
            return { ...state, isSaving: false };
        case LOGGED_OFF:
            return initialState;
        default:
            return state;
    }
};

export const getTenants = () => {
    return async (dispatch) => {
        dispatch({ type: FETCH_TENANTS_REQUESTED });
        try {
            const resp = await Ajax.get('api/tenant/list');
            dispatch({
                type: FETCHED_TENANTS,
                tenants: (resp.data.tenants || []).map((t) => new TenantCompany(t)),
                activeTenantId: resp.data.activeTenantId,
            });
        } catch (err) {
            dispatch({ type: FETCH_TENANTS_FAILED });
        }
    };
};

export const selectTenant = (tenantId) => {
    return (dispatch) => {
        dispatch({ type: SELECT_TENANT_REQUESTED });
        Ajax.put('api/tenant/select/' + tenantId)
            .then(function () {
                dispatch({ type: SELECT_TENANT_SUCCESS, tenantId });
                window.location.reload(true);
            })
            .catch(function () {
                dispatch({ type: SELECT_TENANT_FAILED });
            });
    };
};

export const listAllTenants = () => {
    return async (dispatch) => {
        dispatch({ type: FETCH_ALL_TENANTS_REQUESTED });
        try {
            const resp = await Ajax.get('api/tenant/admin/list');
            dispatch({ type: FETCHED_ALL_TENANTS, data: resp.data });
        } catch (err) {
            dispatch({ type: FETCH_ALL_TENANTS_FAILED });
        }
    };
};

export const saveTenant = (tenant) => {
    return (dispatch) => {
        dispatch({ type: SAVE_TENANT_REQUESTED });
        return new Promise((resolve, reject) => {
            Ajax.post('api/tenant/' + tenant.id, tenant)
                .then(function (resp) {
                    dispatch({ type: SAVED_TENANT, tenant: resp.data });
                    resolve(resp.data);
                })
                .catch(function (err) {
                    dispatch({ type: SAVE_TENANT_FAILED });
                    reject(err);
                });
        });
    };
};
